// extracted by mini-css-extract-plugin
export default {"modalImage":"AddInformationModal_modalImage__z0WDr","modalMenu":"AddInformationModal_modalMenu__XKc3Y"};